import firebase from 'firebase/app';
import React, { useState } from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import * as firebaseui from 'firebaseui';
import { connect } from 'react-redux';
import { useFunctionsEmulatorOnLocal } from '../firebase/firebase';
import { AppMapProps, IAppState } from '../redux/reducer';
import './lobby/lobby.scss';
import { TOS_CURRENT_VERSION } from './TOS';
import HomeButton from './common/HomeButton';

const KEY_ACCEPT_TOS = 'accept-tos';

const _SignIn = ({ debug }: IAppState) => {
  useFunctionsEmulatorOnLocal();

  const uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
    // signInSuccessUrl: '/signedIn',

    signInOptions: [
      { provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID },
      // Disabling Facebook for now until we get reapproved
      // {
      //   provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      //   scopes: ['public_profile', 'email'],
      // },
      firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
      // firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID,
      // firebase.auth.PhoneAuthProvider.PROVIDER_ID,
    ],

    callbacks: {
      signInSuccessWithAuthResult: () => {
        // const from = location.state?.from || { pathname: '/' };
        // history.replace(from);
        return false;
      },
    },
  };

  const alreadyAcceptedTOSVersion = window.localStorage.getItem(KEY_ACCEPT_TOS);
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(
    alreadyAcceptedTOSVersion === TOS_CURRENT_VERSION
  );
  return (
    <>
      <div className='onboarding-container'>
        <HomeButton />
        <div className='onboarding-card'>
          <h2>Welcome to the Backroom</h2>
          <p style={{ color: '#757575' }}>
            where you can watch livestreams while dancing and talking to your friends
          </p>
          <h2>Rules</h2>
          <ul>
            <li>Be kind to one another.</li>
            <li>Consider using headphones or earbuds to prevent sound echoes for others.</li>
            <li>When unmuted, be mindful if you are in a loud space and mute yourself.</li>
            <li>You are responsible for what you do and share.</li>
          </ul>

          {acceptedTerms ? (
            <>
              <br />
              <StyledFirebaseAuth
                uiConfig={{
                  ...uiConfig,
                }}
                firebaseAuth={firebase.auth()}
              />
              <a
                onClick={() => {
                  firebase
                    .auth()
                    .signInAnonymously()
                    .then(() => {
                      // Signed in..
                    })
                    .catch((error) => {
                      var errorCode = error.code;
                      var errorMessage = error.message;
                      // ...
                    });
                }}>
                or sign in anonymously
              </a>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <p>
                <a href='/tos' target='_blank'>
                  Read our Terms of Use and Privacy Policy
                </a>
              </p>
              <input
                value='accept'
                onChange={(e) => {
                  window.localStorage.setItem(KEY_ACCEPT_TOS, TOS_CURRENT_VERSION);
                  setAcceptedTerms(e.target.value === 'accept');
                }}
                id={'accept'}
                type='checkbox'
                checked={acceptedTerms}
                style={{ marginRight: 12 }}
              />
              <label style={{ cursor: 'pointer' }} htmlFor={'accept'}>
                I accept the Terms of Use and Privacy Policy
              </label>
              {alreadyAcceptedTOSVersion ? (
                <>
                  <br />
                  <p>
                    You've already read and accepted a previous version of TOS/PP (
                    {alreadyAcceptedTOSVersion}). Since then, we've updated it and we require you to
                    accept the updated version ({TOS_CURRENT_VERSION}).
                  </p>
                </>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const SignIn = connect(AppMapProps)(_SignIn);
export default SignIn;
